var map = {
	"./1.svg": 1002,
	"./10.svg": 4022,
	"./11.svg": 887,
	"./12.svg": 2676,
	"./2.svg": 3353,
	"./3.svg": 1608,
	"./4.svg": 9207,
	"./5.svg": 9670,
	"./6.svg": 2629,
	"./7.svg": 1348,
	"./8.svg": 4739,
	"./9.svg": 5346,
	"./clustering.png": 687,
	"./insight1.svg": 2624,
	"./insight2.svg": 8723,
	"./insight3.svg": 9330,
	"./learning1.svg": 7024,
	"./learning2.svg": 7923,
	"./learning3.svg": 8930,
	"./logo.svg": 7612,
	"./num1.png": 1664,
	"./num2.png": 6699,
	"./num3.png": 1346,
	"./num4.png": 2909,
	"./persona.png": 2045,
	"./persona1.png": 8416,
	"./persona2.png": 8267,
	"./problem_statement1.png": 1417,
	"./problem_statement2.png": 450,
	"./process.png": 4134,
	"./synthesis.png": 8523,
	"./testing.jpg": 2601,
	"./visual_design.png": 8848,
	"./visual_design.svg": 1338,
	"./visual_design1.png": 9627,
	"./visual_design2.png": 1296,
	"./visual_design5.png": 2623,
	"./wireframes.svg": 1972
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2254;